module.exports = __webpack_public_path__ + "static/media/raffle.8dbc1dea.png";